import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 101120 101120"
    {...props}
  >
    <defs>
      <style>{".fil2{fill:#1c1b17}.fil1{fill:#000}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974319871168">
        <path
          d="M50560 3463c26011 0 47097 21084 47097 47097 0 26010-21086 47097-47097 47097S3463 76570 3463 50560c0-26013 21086-47097 47097-47097z"
          style={{
            fill: "none",
            stroke: "#000",
            strokeWidth: 6926,
          }}
          className="fill-none stroke1"
        />
        <path
          d="m33347 55965 991 1885c917 2577 1737 3679 3698 5408-953 1229-6722 4228-8576 5279-2999 1702-6908 4500-9424 418-3735-6059 7374-8243 13311-12990zm13669 7178c-9150-2290-9625-7912-8604-14993-2300 1044-5320 2968-7651 4353-3414 2027-12636 6488-14319 9382-1777 3060-1957 6084-286 9202 1238 2311 3952 4451 7751 4404 3926-49 12032-5646 15737-7738l7372-4610zM63198 63297c1953-1672 3395-3866 4267-7318 2307 868 6541 3619 8945 5045 2402 1424 7521 3594 4781 7962-2469 3934-6490 1335-9474-437-1906-1129-7580-4092-8519-5252zm14427-6659-14834-8488c1565 9333-1082 12588-8565 15023 852 1097 6393 4034 7569 4698 2570 1451 4959 2843 7418 4259 2605 1500 4974 3552 8803 3348 3364-177 5966-2317 7149-4639 1558-3057 1119-7010-668-9415-1571-2115-4478-3408-6872-4786z"
          className="fill"
        />
        <path
          d="M46259 34244c-214-3724-39-7801-56-11571-19-3852 430-6919 4571-6796 3990 121 4279 3528 4271 7151-8 3451 247 7890-83 11216-3593-917-5124-891-8703 0zm-4354 7780c2132-1496 4549-4007 8525-4078 4371-77 6294 2428 8969 4050 0-6557-18-13119 4-19674 47-12961-11457-12479-15427-7852-1840 2145-2183 4349-2169 7852 20 5795-506 14246 98 19702z"
          className="fill stroke1"
          style={{
            stroke: "#1c1b17",
            strokeWidth: 1055.52,
          }}
        />
        <path
          d="M46314 52373c-1446-5876 7236-7727 8561-2331 1485 6046-7228 7732-8561 2331zm2135-9604c-11594 3114-6605 19871 4387 16964 4083-1084 7719-5185 6291-10765-1057-4135-5392-7618-10678-6199zM63198 63297c939 1160 6613 4123 8519 5252 2984 1772 7005 4371 9474 437 2740-4368-2379-6538-4781-7962-2404-1426-6638-4177-8945-5045-872 3452-2314 5646-4267 7318zM46259 34244c3579-891 5110-917 8703 0 330-3326 75-7765 83-11216 8-3623-281-7030-4271-7151-4141-123-4590 2944-4571 6796 17 3770-158 7847 56 11571zM33347 55965c-5937 4747-17046 6931-13311 12990 2516 4082 6425 1284 9424-418 1854-1051 7623-4050 8576-5279-1961-1729-2781-2831-3698-5408l-991-1885z"
          className="fill"
        />
        <path
          d="M46314 52373c1333 5401 10046 3715 8561-2331-1325-5396-10007-3545-8561 2331z"
          className="fill"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
